import { Contenedor } from 'app/view/impo/impo';
import { Component, OnInit, Input } from '@angular/core';
import { EmptyEnumClass, TypeCheckEnum } from '../type-check-enum';

@Component({
	moduleId: module.id,
	selector: 'app-navigation-type-check-box',
	template: `
    <div class="box-conta" *ngFor="let item of itemsToDrop" [dragDirective]='item' [dragHightlight]="'highlight'" (releaseDrop)="releaseDrop($event)" (startDrag)="startDrag(item)">
    	<app-generic-box-box [contenedor]='item'></app-generic-box-box>
    </div>
  `
})


export class NavigationTypeCheckComponentBox {
	@Input()
	dropItemType: any;


	private pegType = TypeCheckEnum;
	@Input() itemsToDrop: Array<Contenedor>;



	constructor() { }


	private releaseDrop(event) {
		let index = this.itemsToDrop.indexOf(event);
		if (index >= 0) {
			setTimeout(() => { (this.checkType(event, index), 100) });
		}
	}
	private checkType(event, index) {
		if (event.type === this.dropItemType) {
			this.itemsToDrop.splice(index, 1);
		}
	}
	private startDrag(item) {
		//console.log('Begining to drag item: ' + JSON.stringify(item));
	}
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/drag_expo/type-check/navigation-type-check/navigation-type-check.component.ts